import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'trackerManagementExperience.trackerPositionsExport'

const TrackerManagementTrackerPositionsExportSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default TrackerManagementTrackerPositionsExportSlice
